import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 pb-3 border-bottom-grey-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey" }, "Ganti status bus dan tuliskan keterangan alasan penggantian dibawah ini")
], -1)
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Status", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Keterangan", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Template Pesan ")
const _hoisted_10 = {
  key: 0,
  class: "border-grey-6 px-4 py-2 rounded-lg"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "container-btn-action" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Simpan")

import Button from 'primevue/button'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import ConfirmModal from '@/views/components/modal/ConfirmModal2.vue'
import rgxExp from '@/utils/helpers/regExp'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeStatusForm',
  emits: ["showConfirmDialog"],
  setup(__props, { emit }: { emit: ({
  (event: 'showConfirmDialog', data: any, isChange: any): void
}), expose: any, slots: any, attrs: any }) {

const endpointRemarkTemplate = '/management/v1/MsRemarkTemplate'



const moduleStore = 'hjpTable'
const endpointRoster = '/roster/v1/Roster'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)
const remarkTemplateOptions = ref([]) as any
const showTemplateOptions = ref(false)
const refConfirmModal = ref<InstanceType<typeof ConfirmModal>>()
const refForm = ref<InstanceType<typeof Form>>()

const initialValues = {
  Status: {
    label: store.state.hjpTable.modal.data?.RosterStatusName,
    value: store.state.hjpTable.modal.data?.MsStatusRosterId
  },
  Description: ''
}

const schema = Yup.object().shape({
  Status: Yup.object().required('Status tidak boleh kosong'),
  Description: Yup.string()
    .max(100, 'Keterangan maksimal 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi.')
    .required('Keterangan tidak boleh kosong.')
})

const onSubmit = (values: any) => {
  emit('showConfirmDialog', values, true)
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const applyTemplate = (data: any) => {
  const currValue = refForm.value?.getValues()?.Description
  // eslint-disable-next-line no-unused-expressions
  refForm.value?.setFieldValue('Description', currValue ? `${currValue} ${data}` : `${data}`)
}

const getRemarkTemplate = async () => {
  store.dispatch('showLoading')
  const { result, error } = await apiUseCase.get(`${endpointRemarkTemplate}${returnUrlPrams({
    custom: [['IsActive', '=', 'true'], ['IsDeleted', '=', 'false']]
  })}`)
  if (!error) {
    // eslint-disable-next-line array-callback-return
    result.map((item: any) => {
      const data = {
        ...item,
        label: item.TemplateCode,
        value: item.TemplateCode
      }
      remarkTemplateOptions.value.push(data)
    })
  }
  store.dispatch('hideLoading')
}

onMounted(() => {
  getRemarkTemplate()
  store.dispatch('setTitleFormSidebar', 'Ganti Status')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container",
      ref_key: "refForm",
      ref: refForm
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Field), { name: "Status" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(SelectFetch, _mergeProps(field, {
                modelValue: field.value,
                inputId: "statusInput",
                endpoint: "/roster/v1/MsStatusRoster",
                fieldLabel: (v) => v.Name,
                clearable: false,
                searchFields: ['name'],
                placeholder: "Pilih Status"
              }), null, 16, ["modelValue", "fieldLabel"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(errors.Status), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            rows: "5",
            cols: "30",
            maxlength: 100,
            placeholder: "Tulis keterangan",
            class: "",
            id: "status-description"
          }),
          _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "mb-3 text-primary cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showTemplateOptions.value = !showTemplateOptions.value))
          }, [
            _hoisted_9,
            _createElementVNode("i", {
              class: _normalizeClass(["text-primary", showTemplateOptions.value ? 'pi pi-angle-down' : 'pi pi-angle-right'])
            }, null, 2)
          ]),
          (showTemplateOptions.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remarkTemplateOptions), (data, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: data }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["cursor-pointer pb-2", index === 0 ? '' : 'pt-2 border-top-grey-6']),
                      onClick: ($event: any) => (applyTemplate(data.value))
                    }, _toDisplayString(data.label), 11, _hoisted_11)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(ConfirmModal, {
      ref_key: "refConfirmModal",
      ref: refConfirmModal
    }, null, 512)
  ]))
}
}

})